import {Component} from '@angular/core';

@Component({
    selector: 'imageMagicks',
    template:`<div class="panel panel-default" style="padding: 10px;">
        <button data-toggle="collapse" href="#imageMagicks" role="button" aria-expanded="false"
                aria-controls="imageMagicks" type="button" class="btn btn-primary ">Add Image Magicks Script
        </button>
        <div class="collapse" id="imageMagicks">
            <table>
                <tr>
                    <textarea id="w3mission" rows="10" cols="180"></textarea>
                </tr>
                <tr>
                    <button type="button" class="btn btn-success btn-sm ffmpegOkBtn" data-toggle="tooltip" data-placement="bottom"
                            title="Create Table" (click)="onCreateImageMagickScript()">
                        Create Image Magicks Script
                    </button>
                </tr>
            </table>
        </div>
    </div>`,
    styles:[`.ffmpegOkBtn{float: right}`]
})
export class ImageMagicksDefinitionComponent {


    onCreateImageMagickScript() {
    }
}
